
function InfoBar(){

    function closeInfoBar(e){

        console.log(e)

        e.target.parentElement.style.display='none';

    }


    return(
        <div className="infoBar">
        <span className="closeInfoBar" onClick={closeInfoBar}>&times;</span>
        <p>PP-22 social events may be open to all participants or have a limited participation, such as Heads of Delegation only. For the comfort of all participants, please check and respect the “invitation to” column before attending an event.
        </p>
        </div>
    )

}

export default InfoBar;